<apx-chart *ngIf="dataLoaded && apexLineChart.series && apexLineChart.series.length>0 && apexLineChart.series[0].data.length>0"
    [series]="apexLineChart.series"
    [chart]="{
        type: 'line',
        height: chartRenderHeight,
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false
        }
        }"
    [width]="getWidth() || 'auto'"
    [xaxis]="apexLineChart.xaxis"
    [yaxis]="apexLineChart.yaxis"
    [stroke]="apexLineChart.stroke"
    [markers]="apexLineChart.markers"
    [tooltip]="apexLineChart.tooltip"
    [colors]="apexLineChart.colors"
    [dataLabels]="apexLineChart.dataLabels"
    [grid]="apexLineChart.grid"
           [legend]="apexLineChart.legend"
></apx-chart>

<div class="time-axis" *ngIf="dataLoaded && compact && reduceGrid && showTimeAxis" aria-label="Horas del día">
    <span>00:00</span>
    <span>06:00</span>
    <span>12:00</span>
    <span>18:00</span>
    <span>24:00</span>
</div>
